/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { GridOptionsExt } from '../features/ext/grid-options-ext';
import { GridModel } from '../state/grid-state.interfaces';
import { GridLayout } from './grid-layout';
import {
  LayoutBasedGridDefinitionWithModel,
  ManualGridDefinitionWithModel,
} from './grid-model-support';
import { LayoutBasedGridDefinition } from './layout-based-grid-definition';
import { ManualGridDefinition } from './manual-grid-definition';

export interface LayoutBasedGridDefinitionOptions {
  columns?: Hash<ColDef>;
  model: GridModel;
  options?: GridOptionsExt;
  layout?: GridLayout;
}

export interface ManualGridDefinitionOptions {
  columns?: ColDef[];
  model: GridModel;
  options?: GridOptionsExt;
}

@Injectable()
export class GridDefinitionFactory {
  buildLayoutBased(colDefs: Hash<ColDef> = {}, options: GridOptionsExt = {}): LayoutBasedGridDefinition {
    class ExtendedLayoutBasedGridDefinition extends LayoutBasedGridDefinition {
      columnDefs = colDefs;
      options = options;
    }

    return new ExtendedLayoutBasedGridDefinition();
  }

  buildLayoutBasedWithModel({
                              columns, model,
                              options, layout,
                            }: LayoutBasedGridDefinitionOptions): LayoutBasedGridDefinition {
    class SimpleLayoutBasedGridDefinition extends LayoutBasedGridDefinitionWithModel {
      buildColumnDefs(): Hash<ColDef> {
        return columns || {};
      }

      buildGridModel(): GridModel {
        return model;
      }

      buildGridOptions(): GridOptionsExt {
        return options || {};
      }
    }

    const gridDefinition = new SimpleLayoutBasedGridDefinition();
    if (layout) {
      gridDefinition.bind(layout);
    }
    return gridDefinition;
  }

  buildManual(colDefs: ColDef[], options: GridOptionsExt = {}): ManualGridDefinition {
    class SimpleManualGridDefinition extends ManualGridDefinition {
      buildColumnDefs(): ColDef[] {
        return colDefs;
      }

      buildGridOptions(): GridOptionsExt {
        return options;
      }
    }

    return new SimpleManualGridDefinition();
  }

  buildManualWithModel({ columns, model, options }: ManualGridDefinitionOptions): ManualGridDefinitionWithModel {
    class SimpleManualGridDefinition extends ManualGridDefinitionWithModel {
      buildColumnDefs(): ColDef[] {
        return columns || [];
      }

      buildGridModel(): GridModel {
        return model;
      }

      buildGridOptions(): GridOptionsExt {
        return options || {};
      }
    }

    return new SimpleManualGridDefinition();
  }
}
